import * as React from 'react';
import * as styles from './PictureTemplate.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var PictureTemplate = function PictureTemplate(props) {
  var imageURL = props.imageURL,
    alt = props.alt,
    width = props.width,
    reference = props.reference;
  return /*#__PURE__*/_jsx("a", {
    href: reference,
    target: "_blank",
    rel: "noreferrer noopener nofollow",
    style: {
      width: width
    },
    className: styles['container'],
    children: /*#__PURE__*/_jsx("img", {
      className: styles['image'],
      src: imageURL,
      alt: alt
    })
  });
};